/**
 * Sticky offer bar.
 *
 * Past a threshold the bar takes the header's place: it slides in and the theme
 * header is held back, so scrolling up no longer summons it. Return to the top
 * and the bar leaves, the header and whatever sits above it come back.
 *
 * The header is suppressed by a class on <body> rather than by fighting
 * header.js — that script keeps setting data-sticky-state as it likes, and CSS
 * simply outranks it while the bar is out.
 */
(function () {
  var SELECTOR = '[data-sticky-offer]';
  var BODY_CLASS = 'sticky-offer-active';

  function setup(bar) {
    if (bar.stickyOfferReady) return;
    bar.stickyOfferReady = true;

    var threshold = parseInt(bar.getAttribute('data-threshold'), 10);
    if (isNaN(threshold)) threshold = 400;

    var takeover = bar.getAttribute('data-takeover') === 'true';
    var shown = false;

    function apply(next) {
      if (next === shown) return;
      shown = next;

      bar.classList.toggle('sticky-offer--shown', shown);
      bar.setAttribute('aria-hidden', shown ? 'false' : 'true');

      if (takeover) {
        document.body.classList.toggle(BODY_CLASS, shown);
      }
    }

    // One property read and a class toggle, and apply() returns early unless the
    // state actually changes — cheap enough to run straight off the event. A
    // rAF gate here only risks latching shut when frames are throttled.
    function measure() {
      var y = window.scrollY || document.documentElement.scrollTop || 0;
      apply(y > threshold);
    }

    window.addEventListener('scroll', measure, { passive: true });
    window.addEventListener('resize', measure);
    measure();

    // The editor re-renders sections; make sure a removed bar frees the header.
    document.addEventListener('shopify:section:unload', function (event) {
      if (event.target.contains(bar)) document.body.classList.remove(BODY_CLASS);
    });
  }

  function init(root) {
    var scope = root && root.querySelectorAll ? root : document;
    Array.prototype.forEach.call(scope.querySelectorAll(SELECTOR), setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
